import { render, staticRenderFns } from "./companyForm.vue?vue&type=template&id=6278d302&%23default=true&"
import script from "./companyForm.vue?vue&type=script&lang=js&"
export * from "./companyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports